/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Movement_Executions_WaitingInputs */

const en_queue_movement_executions_waiting = /** @type {(inputs: Queue_Movement_Executions_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse executions to apply`)
};

/**
* | output |
* | --- |
* | "Warehouse executions to apply" |
*
* @param {Queue_Movement_Executions_WaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_movement_executions_waiting = /** @type {((inputs?: Queue_Movement_Executions_WaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Movement_Executions_WaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_movement_executions_waiting(inputs)
});